import React from 'react'

import Checkbox from './Checkbox'

const RadioOptions = ({
  label1,
  label2,
  selectedOption,
  option1,
  option2,
  onSelect,
  isDisabled,
  marginTop,
  color
}) => {
  return (
    <div style={{display: "flex", marginTop, alignItems: "center", justifyContent: "start", fontFamily: "Futura", fontSize: "min(4.5vw, 18px)"}}>
      <div style={{marginInlineEnd: "1em", display: "flex", alignItems: "top", justifyContent: "start"}}>
        <Checkbox
          isChecked={option1 === selectedOption}
          isDisabled={isDisabled}
          setIsChecked={(val) => onSelect(option1)}
          checkboxClass={"checkbox-white"}
        />
        <div style={{marginInlineStart: "0.3em", color: color || "#000000"}}>{label1}</div>
      </div>
      <div style={{display: "flex", alignItems: "top", justifyContent: "start"}}>
        <Checkbox
          isChecked={option2 === selectedOption}
          isDisabled={isDisabled}
          setIsChecked={(val) => onSelect(option2)}
          checkboxClass={"checkbox-white"}
        />
        <div style={{marginInlineStart: "0.3em", color: color || "#000000"}}>{label2}</div>
      </div>
    </div>
  );
}

export default RadioOptions;